import {
  HTTP_INTERNAL_SERVER_ERROR,
  HTTP_NOT_FOUND,
  HTTP_UNAUTHORIZED,
  NYLAS_AUTHENTICATION_ERROR_KIND,
} from '../constants/common';
import { hasValue } from './equality';

export type EmailSendFailure = {
  status: number | undefined;
  kind: string | undefined;
};

// Sending names no resource but the user's Nylas grant, so a 404 means the grant is gone.
export const isEmailConnectionError = ({ status, kind }: EmailSendFailure): boolean =>
  status === HTTP_UNAUTHORIZED ||
  status === HTTP_NOT_FOUND ||
  kind === NYLAS_AUTHENTICATION_ERROR_KIND;

export const emailSendErrorMessage = ({ status }: EmailSendFailure): string =>
  hasValue(status) && status < HTTP_INTERNAL_SERVER_ERROR
    ? "We couldn't send the email. Check the recipients and attachments, then try again."
    : "We couldn't send the email. Try again in a few minutes.";
